import React from 'react';

import { SimpleFooter } from '@britishcouncil/react-solas';

export const Footer = () => {
  return (
    <SimpleFooter
      centered
      size="large"
    />
  );
};
